import i18n from 'helpers/i18n';
import messages from './messages';

export const SECOND_EDITION = '2nd Edition';

const SECOND_EDITION_PRE_K_3RD_SLUGS = [
  'pre-kindergarten',
  'kindergarten-to-3rd',
  'pre-kindergarten-3rd'
];

const AGE_LEVELS: Record<
  string,
  { message: { key: string; defaultValue: string }; color: string }
> = {
  infant: { message: messages.infant, color: 'bg-[#FDC4DC] text-black' },
  toddler: { message: messages.toddler, color: 'bg-[#EAFCC1] text-black' },
  'infant-toddler': {
    message: messages.infantToddler,
    color: 'bg-[#CDE7DB] text-black'
  },
  'pre-kindergarten': {
    message: messages.preK,
    color: 'bg-[#4B5563] text-white'
  },
  'kindergarten-to-3rd': {
    message: messages.k3,
    color: 'bg-[#FFD615] text-black'
  },
  'pre-kindergarten-3rd': {
    message: messages.preK3rd,
    color: 'bg-[#6E2262] text-white'
  },
  'pre-k-kindergarten': {
    message: messages.preKK,
    color: 'bg-[#0079C1] text-white'
  },
  'upper-elementary': {
    message: messages.upperElementary,
    color: 'bg-[#4B5563] text-white'
  },
  secondary: { message: messages.secondary, color: 'bg-[#4B5563] text-white' }
};

function resolveAgeLevelSlug(classVersion: string, ageLevelGroup: string) {
  if (
    classVersion === SECOND_EDITION &&
    SECOND_EDITION_PRE_K_3RD_SLUGS.includes(ageLevelGroup)
  ) {
    return 'pre-kindergarten-3rd';
  }

  return ageLevelGroup;
}

export function getAgeLevelTag(classVersion: string, ageLevelGroup: string) {
  const ageLevel = AGE_LEVELS[resolveAgeLevelSlug(classVersion, ageLevelGroup)];

  return {
    label: ageLevel ? i18n.ft(ageLevel.message) : ageLevelGroup,
    color: ageLevel?.color ?? 'bg-[#4B5563] text-white'
  };
}

export function getEditionColor(classVersion: string) {
  if (classVersion === SECOND_EDITION) return 'bg-[#61810D]';
  if (classVersion === '2008') return 'bg-[#0880A6]';
  return 'bg-[#4B5563]';
}
